type Props = {
  show: boolean;
};

export default function TiltMessage({ show }: Props) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 z-[9999] flex flex-col items-center justify-center px-6 text-white text-center animate-fade-in transition-opacity">

      <img
        src="\Rotate Device to Landscape.png"
        alt="Rotate your phone"
        className="w-48 animate-tilt mb-6"
      />
      <p className="text-sm mt-2">For best experience, use landscape mode.</p>
    </div>
  );
}
